import { eventEditorStore } from '../event-editor.store';

export const getEventEditorState = () => eventEditorStore.getState();
